/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import SEO from './seo';
import Hero from './default/hero';
import Footer from './default/footer';
// import I18nModal from './default/i18nModal';
import CookieMessage from './default/cookieMessage';
import { WebNav } from './default/navigation';
import { DEFAULT_LANGUAGE } from '../providers/globalDataProvider/globalDataProvider.provider';

const Layout = function ({
  children,
  title,
  pageTitle,
  imageFileName,
  imageTitle,
  imageAlt,
  primaryText,
  secondaryText,
  headerImageExtraClass,
  location,
  language,
  imagePosition,
  description,
  keywords,
}) {
  const WebNavigation = useCallback(() => <WebNav />, []);
  const WebFooter = useCallback(() => <Footer />, []);
  const WebCookies = useCallback(() => <CookieMessage />, []);
  const WebSEO = useCallback(() => {
    const nLocation = {
      pathname: '',
      search: '',
    };
    const { pathname, search } = location || nLocation;
    return (
      <SEO
        description={description}
        title={title}
        keywords={keywords}
        lang={language}
        pathname={pathname}
        search={search}
        pageTitle={pageTitle}
      />
    );
  }, [location, description, title, keywords, language, pageTitle]);

  const WebHero = useCallback(
    () => (
      <Hero
        imageFileName={imageFileName}
        imageTitle={imageTitle}
        imageAlt={imageAlt}
        primaryText={primaryText}
        secondaryText={secondaryText}
        headerImageExtraClass={headerImageExtraClass}
        imagePosition={imagePosition}
        title={title}
      />
    ),
    [
      imageFileName,
      imageTitle,
      imageAlt,
      primaryText,
      secondaryText,
      headerImageExtraClass,
      imagePosition,
      title,
    ],
  );

  return (
    <>
      <WebSEO />
      <WebHero />
      <WebNavigation />
      <main>
        {/* <I18nModal /> */}
        {children}
      </main>
      <WebFooter />
      <WebCookies />
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
  headerImageExtraClass: PropTypes.string,
  imageFileName: PropTypes.string,
  imagePosition: PropTypes.string,
  language: PropTypes.string,
  location: PropTypes.shape({}).isRequired,
  primaryText: PropTypes.string,
  secondaryText: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  imageTitle: PropTypes.string,
  imageAlt: PropTypes.string,
  pageTitle: PropTypes.string,
};

Layout.defaultProps = {
  title: undefined,
  description: undefined,
  keywords: undefined,
  primaryText: '',
  secondaryText: '',
  language: DEFAULT_LANGUAGE,
  children: null,
  headerImageExtraClass: undefined,
  imageFileName: undefined,
  imagePosition: '70%',
  imageTitle: undefined,
  imageAlt: undefined,
  pageTitle: undefined,
};

export default Layout;
